<template>
  <div>
    <span @click="modal = true">
      <slot></slot>
    </span>

    <modal @close="modal = false" :open="modal" :maxWitdh="'600px'">
      
      <div class="ar-card">
        <div class="ar-card-header">
          <div class="ar-card-title">
            افزودن حساب بانکی 
          </div>
          <span>
            <i @click="modal = false" class="mdi mdi-close"></i>
          </span>
        </div>
        <div class="ar-card-body">

          <div class="pb-3">
            <small>
              کاربر گرامی: صورت مغایرت حساب بانکی احراز شده و فیش واریزی , مبلغ واریزی بعد از 72 ساعت به حساب مبدأ عودت داده خواهد شد.
            </small>
          </div>
          
          <div class="ar-form-group">
            <label>شماره کارت</label>
            <the-mask class="ar-form-control text-center latin-input-3" :masked="true" v-model="user_bank_account.card_number" placeholder="XXXX-XXXX-XXXX-XXXX" :mask="[
              '####',
              '####-##',
              '####-###',
              '####-####',
              '####-####-#',
              '####-####-##',
              '####-####-###',
              '####-####-####',
              '####-####-####-#',
              '####-####-####-##',
              '####-####-####-###',
              '####-####-####-####'
            ]" />
            <div v-if="errors.card_number" class="ar-form-text">
              <small>{{errors.card_number[0]}}</small>
            </div>
          </div>
          
          <div class="ar-form-group">
            <label>شماره شبا</label>
            <the-mask class="ar-form-control text-center latin-input-3" :masked="true" v-model="user_bank_account.shaba_number" placeholder="" :mask="[
              '########################################'
            ]" />
            <div v-if="errors.shaba_number" class="ar-form-text">
              <small>{{errors.shaba_number[0]}}</small>
            </div>
          </div>

          <h4 class="text-center mt-5">تصویر کارت بانکی خود را انتخاب کنید</h4>
          <label for="card_image" class="buy-sell-upload">
            <input type="file" id="card_image" @change="card_image_changed($event)">
            <span>آپلود</span>
            <i style="font-size : 24px" class="mdi mdi-cloud-upload-outline"></i>
          </label>

          <div v-if="card_image" class="text-center mt-2">
            {{ card_image.name }}
          </div>
          
        </div>
        <div class="ar-card-footer">
          <button @click="addUserBankAccount()" class="ar-btn size-sm primary">ثبت</button>
          <button @click="modal = false" class="ar-btn size-sm outline-primary mx-3">انصراف</button>
        </div>
      </div>

    </modal>

  </div>
</template>
<script>
import Modal from './Modal.vue'
import {TheMask} from 'vue-the-mask'
import {io} from 'socket.io-client';
export default {
  name: 'AddBankAccount',
  components:{
    Modal,
    TheMask
  },
  props:{
  },
  data : () => ({
    modal:false,
    user_bank_account:{},
    errors:{},
    card_image : null,
    socket : null,
  }),
  watch:{
    
  },
  methods:{
    card_image_changed(event){
      this.card_image = event.target.files[0];
    },
    addUserBankAccount (){
      this.errors = {}
      this.activeLoading(true)
      const api_token = this.getToken()
      const d = new FormData();

      this.card_image ? d.append('card_image', this.card_image) : ''
      this.user_bank_account.card_number ? d.append('card_number', this.user_bank_account.card_number) : ''
      this.user_bank_account.shaba_number ? d.append('shaba_number', this.user_bank_account.shaba_number) : ''

      this.$axios.post(`addUserBankAccount` , d,
      {
        headers: {
          'api_token':api_token
        }
      })
      .then(res => {
        this.StoreBankAccounts(res.data.data)
        this.activeLoading(false)
        this.errors = {}
        this.user_bank_account = {}
        this.socket.emit('admin_notification');
        this.modal = false
        this.$notify({
          group: 'foo',
          type: 'success',
          duration: 5000,
          text: 'کارت بانکی با موفقیت ثبت شد.'
        });
      })
      .catch(err => {
        this.activeLoading(false)
        this.errors = err.response.data.errors
      });

    },
  },
  computed:{
  },
  mounted() {
    this.socket = io(this.socketUrl);
    
  }
}
</script>